import { TRuleWithTheme } from 'styles/theme';

export const button: TRuleWithTheme = () => ({
    padding:'0px',
    flex: '0 0 190px',
});
